/** Horizontal padding between bar edge and label text. */
export const BAR_LABEL_PADDING = 4;

/**
 * Minimum size (in pixels) for the bar dimension perpendicular to the text
 * reading direction (bar height for horizontal text, bar width for rotated
 * vertical text). Below this there is no readable space for text.
 */
export const BAR_LABEL_MIN_SIZE = 16;
